import React, { useEffect, useState } from "react";
import styles from "./MailAuth.module.css";
import { useNavigate } from "react-router-dom";
import { authCursoLogic } from "../../../Logic/AuthCurso";
import { Typography } from "@mui/material";
import { authMailLogic } from "../../../Logic/AuthMail";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void; // Se ejecuta cuando el login es correcto
}

const MailAuth: React.FC<ModalProps> = ({ isOpen, onClose, onSuccess }) => {
    const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [checkAvisoPrivacidad, setCheckAvisoPrivacidad] = useState(false)

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {

        const formData = new FormData();
      formData.append("Email", email.trim());

        await authMailLogic.VerificarMail(formData).then((response) => {
                if(response.exists){

                  const nombre = response.nombre;
                  const apellido = response.apellido;

                   // Guardar datos en localStorage
                    localStorage.setItem("usuarioRegistrado", JSON.stringify({
                      nombre,
                      apellido,
                      email,
                    }));

                    onSuccess();
                }
                else    
                  setError("Correo no registrado. Contacta con el administrador.");
        });

 
    } catch (err) {
      setError("Error al identificar. Intenta de nuevo");
    } finally {
      setLoading(false);
    }
  };

    const handleClose = () => {
        setError("");
    onClose()
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modalContainer}>
        {/* Botón Cerrar (X) */}
        <button className={styles.closeButton} onClick={handleClose}>✖</button>

         <h2 className={styles.title}>IDENTIFÍCATE</h2>
       
 <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.inputGroup}>
            <label>Correo Electrónico</label>
            <input 
              type="email" 
              placeholder="tu@correo.com" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Typography variant="body1" align="center" sx={{ margin: 1 }}>
            <input 
            style={{width:"auto", marginRight:"5px"}}
            type="checkbox"
             checked={checkAvisoPrivacidad} 
             required   
             onChange={(e) => setCheckAvisoPrivacidad(e.target.checked)}
             /> 
             He leído y acepto el
            <a href="/privacidad" target="_blank">
              Aviso de Privacidad
            </a>
          </Typography>
          </div>

          {error && <p className={styles.errorMessage}>{error}</p>}

          <button type="submit" className={styles.submitButton} disabled={loading}>
            {loading ? "VERIFICANDO..." : "VERIFICAR"}
          </button>
        </form> 
        
      </div>
    </div>
  );
};

export default MailAuth;